import { Component, Event, EventEmitter, h, State } from '@stencil/core';
import store from '../../../helpers/store';

import Events from '../../../helpers/Events';
import { FlowStatus } from '../../../models/FlowStatus';
import { ApiCall } from '../../../helpers/ApiCall';
import { FlowSteps } from '../../../models/FlowSteps';
import { Cameras } from '../../../helpers/Cameras';
import { BaseComponent } from '../../base-component';
import { MobileOS } from '../../../models/IDevice';
import { TranslationValues } from '../../../models/ITranslationValues';

// @ts-ignore
import info from '../../../assets/landing/info.svg';
// @ts-ignore
import idSvg from '../../../assets/landing/ico-id.svg';
import idDevice from '../../../assets/landing/ico-phone.svg';

import { Translations } from '../../../helpers/TranslationUtils';
import { EctData } from '../../../helpers/EctDb';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';
import logoOntrace from '../../../assets/logo-ontrace.svg';
import { db } from '../../../helpers/db';

@Component({
  tag: 'landing-validation',
  styleUrl: 'landing-validation.css',
  shadow: false,
})
export class LandingValidation {
  @State() warningText: string;
  @State() buttonDisabled: boolean;
  private translations: TranslationValues;
  private ectData: EctData;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  constructor() {}

  async componentWillLoad() {
    Events.flowStarted();
    this.translations = await Translations.getValues();
    this.buttonDisabled = false;

    this.ectData = await db.ectdata.get(store.requestId);

    await this.initRequest();
  }

  async componentDidLoad() {
    await BaseComponent.initialize(FlowSteps.Landing);
  }

  async initRequest() {
    if (store.apiBaseUrl.includes('apimd')) {
      this.warningText = this.translations.LandingValues.WarningMd;
    } else {
      this.warningText = this.translations.LandingValues.Warning;
    }
  }

  async startFlow() {
    if (!this.buttonDisabled) {
      this.buttonDisabled = true;

      var cameraIsAccessible = await Cameras.InitCameras(store.device);
      if (!cameraIsAccessible && (store.device.os.name === MobileOS.iOS || store.device.os.name === MobileOS.MacOS)) {
        this.ectData.refreshStarted = false;
        await db.ectdata.put(this.ectData);
      }

      try {
        store.flowStatus = await ApiCall.instance.LandingValidationStartFlow(cameraIsAccessible);
      } catch (e) {
        this.apiErrorEvent.emit(e);
      }
    }
  }

  async disconnectedCallback() {
    await BaseComponent.finalize(FlowSteps.Landing);
  }

  async leaveFlow() {
    if (this.buttonDisabled) return;

    try {
      let abortResult = await ApiCall.instance.AbortRequest();
      store.flowStatus = FlowStatus[abortResult.state];

      await db.ectdata.delete(store.requestId);

      Events.flowAborted();
    } catch (e) {
      Events.flowAborted();
      this.apiErrorEvent.emit(e);
    }
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-4">
          <h1 class="text-center px-1 mb-1">{this.translations.LandingValues.Title}</h1>

          <div class="info-container mb-2">
            <div class="img-text">
              <div class="bg-img">
                <img src={idSvg}></img>
              </div>
              <h2>{this.translations.LandingValues.IdInfo}</h2>
            </div>
            <div class="img-text">
              <div class="bg-img">
                <img src={idDevice}></img>
              </div>
              <h2>{this.translations.LandingValues.DeviceInfo}</h2>
            </div>
          </div>

          <div class="button flex mb-1">
            {this.buttonDisabled ? (
              <div class="img-loader rounded img-loader-button">
                <img class="loading-image loading-image-button" src={loaderImg}></img>
              </div>
            ) : null}
            <button class="main-button" type="button" disabled={this.buttonDisabled} onClick={() => this.startFlow()}>
              {this.translations.LandingValues.Button}
            </button>
          </div>

          <div class="text-center">
            <p class="main-text link-text" onClick={() => this.leaveFlow()}>
              {this.translations.LandingValues.ButtonLeave}
            </p>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
